import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import { getUser } from '../api/API/login'

Vue.use(VueRouter)
const Index = () => import(/* webpackChunkName:'Index' */ '../pages/Index')
const Home = () => import(/* webpackChunkName:'Index' */ '../pages/home/Home')
const Consult = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Consult')
const List = () => import(/* webpackChunkName:'List' */ '../pages/list/List')
const List1688 = () => import(/* webpackChunkName:'List' */ '../pages/list/1688list')
const Details = () => import(/* webpackChunkName:'Details' */ '../pages/details/Details')
const Details1688 = () => import(/* webpackChunkName:'Details' */ '../pages/details/Details1688')
const Login = () => import(/* webpackChunkName:'Login' */ '../pages/login/Login')
const Register = () => import(/* webpackChunkName:'Register' */ '../pages/register/Register')
const NewUser = () => import(/* webpackChunkName:'NewUser' */ '../pages/register/NewUser')
const User = () => import(/* webpackChunkName:'User' */ '../pages/user/User')

const UserIndex = () => import(/* webpackChunkName:'User' */ '../pages/user/users/Index')
const Cart = () => import(/* webpackChunkName:'Cart' */ '../pages/cart/Cart')
const Zhuwen = () => import(/* webpackChunkName:'Cart' */ '../pages/cart/Zhuwen')
const Hotboom = () => import(/* webpackChunkName:'Cart' */ '../pages/cart/shoppingCart/Hotboom')
const Error1 = () => import(/* webpackChunkName:'Error' */ '../pages/error/Error')
const ProceedOrder = () => import(/* webpackChunkName:'User' */ '../pages/user/users/ProceedOrder')
const IssueProduct = () => import(/* webpackChunkName:'User' */ '../pages/user/users/IssueProduct')
const Warehouse = () => import(/* webpackChunkName:'User' */ '../pages/user/users/Warehouse')
const DeliverOrder = () => import(/* webpackChunkName:'User' */ '../pages/user/users/DeliverOrder')
const Shop = () => import(/* webpackChunkName:'User' */ '../pages/user/users/Shop')
const Commodity = () => import(/* webpackChunkName:'User' */ '../pages/user/users/Commodity')
const newCommodity = () => import(/* webpackChunkName:'User' */ '../pages/user/users/newCommodity.vue')
const favoriteShop = () => import(/* webpackChunkName:'User' */ '../pages/user/users/favoriteShop.vue')
const Merchandise = () => import(/* webpackChunkName:'User' */ '../pages/user/users/Merchandise')
const productState = () => import(/* webpackChunkName:'User' */ '../pages/user/users/productState')

const Golden = () => import(/* webpackChunkName:'User' */ '../pages/user/users/Golden')

const GoldenRecord = () => import(/* webpackChunkName:'User' */ '../pages/user/users/GoldenRecord')
const PersonalDetails = () => import(/* webpackChunkName:'User' */ '../pages/user/users/PersonalDetails')
const Site = () => import(/* webpackChunkName:'User' */ '../pages/user/users/Site')
const SonAccount = () => import(/* webpackChunkName:'User' */ '../pages/user/users/SonAccount')
const ChangPssword = () => import(/* webpackChunkName:'User' */ '../pages/user/users/ChangPssword')
const DomesticLogistics = () => import(/* webpackChunkName:'User' */ '../pages/user/users/DomesticLogistics')
const UrlUpload = () => import(/* webpackChunkName:'User' */ '../pages/user/users/UrlUpload')

const Payment = () => import(/* webpackChunkName:'Payment' */ '../pages/payment/Payment')
const PaySucceed = () => import(/* webpackChunkName:'Payment' */ '../pages/payment/PaySucceed')
const Deliver = () => import(/* webpackChunkName:'Payment' */ '../pages/deliver/Deliver')
const LogisticsTrace = () => import(/* webpackChunkName:'foot' */ '../pages/footList/LogisticsTrace')
const Photography = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Photography')
const Introduction = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Introduction')
const Fba = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Fba')
const Guiyue = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Guiyue')
const Poundage = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Poundage')
const Secret = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Secret')
const CommonQuestion = () => import(/* webpackChunkName:'foot' */ '../pages/footList/CommonQuestion')
const Option = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Option')
const rateEcharts = () => import(/* webpackChunkName:'foot' */ '../pages/footList/rateEcharts')

const Wzk = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Wzk')
const Freight = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Freight')
const Course = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Course')
const Calendar = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Calendar')
const Notice = () => import(/* webpackChunkName:'foot' */ '../pages/footList/Notice')
const DeliveryStatus = () => import(/* webpackChunkName:'DeliveryStatus' */ '../pages/user/users/DeliveryStatus/DeliveryStatus')
const characterSecognition = () => import('../pages/character-recognition/character-recognition')

const questionnaire = () => import('../pages/questionnaire/questionnaire')
questionnaire



const routes = [
  // 路由错误
  { name: 'error', path: "*", component: Error1 },
  {
    path: '/',
    redirect: '/',
    name: 'index',
    component: Index,

    children: [
      {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
          title: '首页',   // 标题设置
          content: {
            keywords: '无站库',
            description: '这里是第一个description',
          },
        },
      }
    ]
  },
  // 图片翻译
  {
    path: '/characterSecognition',
    name: 'characterSecognition',
    component: characterSecognition,
  },

  // 搜索列表
  {
    path: '/list',
    name: 'list',
    component: List,
    meta: {
      title: '搜索列表'   // 标题设置
    }

  },
  // 1688 搜索列表
  {
    path: '/list1688',
    name: 'list1688',
    component: List1688,
    meta: {
      title: 'カテゴリー', // 标题设置
      requireAuth: true,
    }
  },
  // 产品详情
  {
    path: '/details',
    name: 'details',
    component: Details,
    meta: {
      title: '商品詳細' ,  // 标题设置
       requireAuth: true,
    }
  },
  // 产品详情 1688
  {
    path: '/details1688',
    name: 'details1688',
    component: Details1688,
    meta: {
      title: '商品詳細',  // 标题设置
       requireAuth: true,
    }
  },
  // 登入
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'ログイン'   // 标题设置
    }
  },
  // 注册
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '新規会員登録'   // 标题设置
    }
  },
  // 注册成功
  {
    path: '/newUser',
    name: 'newUser',
    component: NewUser,
    meta: {
      title: '新規会員登録'   // 标题设置
    }
  },
  // 问题产品
  {
    path: '/issueProduct',
    name: 'issueProduct',
    component: IssueProduct,
    meta: {
      title: '问题产品', // 标题设置
      requireAuth: true,
    }
  },
  //问卷调查
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: questionnaire,
    meta: {
      title: '问卷', // 标题设置
      // requireAuth: true,
    }
  },

  // 用户
  {
    path: '/user',
    name: 'user',
    component: User,
    meta: {
      title: '',
      requireAuth: true,
    },
    children: [
      // user首页
      {
        path: '/user/index', name: 'userindex', component: UserIndex,
        meta: {
          title: 'マイページ'   // 标题设置
        }
      },
      // 进行中的订单
      {
        path: '/user/proceedOrder', name: 'proceedOrder', component: ProceedOrder,
        meta: {
          title: '代行注文書'   // 标题设置
        }
      },
      // 进行中的订单
      {
        path: '/user/productState', name: 'productState', component: productState,
        meta: {
          title: '代行注文書'   // 标题设置
        }
      },

      // 中国国内物流状态
      {
        path: '/user/domesticLogistics', name: 'domesticLogistics', component: DomesticLogistics,
        meta: {
          title: '中国国内物流状態'   // 标题设置
        }
      },


      // 仓库
      {
        path: '/user/warehouse', name: 'warehouse', component: Warehouse,
        meta: {
          title: '倉庫'   // 标题设置
        }
      },
      // 配送单
      {
        path: '/user/deliverOrder', name: 'deliverOrder', component: DeliverOrder,
        meta: {
          title: '配送依頼'   // 标题设置
        }
      },
      // 收藏店铺
      {
        path: '/user/shop', name: 'shop', component: Shop,
        meta: {
          title: '收藏店铺'   // 标题设置
        }
      },
      // 收藏商品
      {
        path: '/user/commodity', name: 'commodity', component: Commodity,
        meta: {
          title: 'お気に入り商品'   // 标题设置
        }
      },
      // 收藏商品
      {
        path: '/user/newCommodity', name: 'newCommodity', component: newCommodity,
        meta: {
         title: 'お気に入り商品'   // 标题设置
        }
      },
      // 收藏店铺
      {
        path: '/user/favoriteShop', name: 'favoriteShop', component: favoriteShop,
        meta: {
         title: 'お気に入り店舗'   // 标题设置
        }
      },
      // 商品库
      {
        path: '/user/merchandise', name: 'merchandise', component: Merchandise,
        meta: {
          title: '商品库'   // 标题设置
        }
      },
      // 入金
      {
        path: '/user/golden', name: 'golden', component: Golden,
        meta: {
          title: '新規入金'   // 标题设置
        }
      },
      // 入金记录
      {
        path: '/user/goldenRecord', name: 'goldenRecord', component: GoldenRecord,
        meta: {
          title: '入金履歴ページ'   // 标题设置
        }
      },
      // 个人信息
      {
        path: '/user/personalDetails', name: 'personalDetails', component: PersonalDetails,
        meta: {
          title: '個人情報'   // 标题设置
        }
      },
      // 地址
      {
        path: '/user/site', name: 'site', component: Site,
        meta: {
          title: '配送先'   // 标题设置
        }
      },
      // 子账号
      {
        path: '/user/sonAccount', name: 'sonAccount', component: SonAccount,
        meta: {
          title: '子账号'   // 标题设置
        }
      },
      // 修改密码
      {
        path: '/user/changPssword', name: 'changPssword', component: ChangPssword,
        meta: {
          title: 'パスワード変更'   // 标题设置
        }
      },
      {
        path: '/user/urlUpload', name: 'urlUpload', component: UrlUpload,
        meta: {
          title: 'URLアップロード'   // 标题设置
        }
      },
    ]
  },
  // 购物车
  {
    path: '/cart', name: 'cart', component: Cart,
    meta: {
      title: '',
      requireAuth: true,
    },
    children: [
      {
        path: '/cart/hotboom', name: 'hotboom', component: Hotboom,
        meta: {
          title: '買い物かご'   // 标题设置
        }
      },

    ]
  },
  // 注文
  {
    path: '/zhuwen',
    name: 'zhuwen',
    component: Zhuwen, meta: {
      title: ' 注文書ページ'   // 标题设置
    }

  },
  // error
  {
    path: '/error',
    name: 'error',
    component: Error1,
    meta: {
      title: 'error'   // 标题设置
    }
  },
  // 联系我们
  {
    path: '/consult',
    name: 'consult',
    component: Consult,
    meta: {
      title: 'お問い合わせ'   // 标题设置
    }
  },
  // 支付界面
  {
    path: '/payment',
    name: 'payment',
    component: Payment,
    meta: {
      title: '支払いページ'   // 标题设置
    }
  },
  // 支付成功
  {
    path: '/paySucceed',
    name: 'paySucceed',
    component: PaySucceed,
    meta: {
      title: '支払いページ'   // 标题设置
    }
  },
  // 配送单
  {
    path: '/deliver',
    name: 'deliver',
    component: Deliver,
    meta: {
      title: '配送依頼'   // 标题设置
    }
  },
  // 物流追踪
  {
    path: '/logisticsTrace',
    name: 'logisticsTrace',
    component: LogisticsTrace,
    meta: {
      title: '物流追跡ページ'   // 标题设置
    }
  },
  // 拍照写真
  {
    path: '/photography',
    name: 'photography',
    component: Photography,
    meta: {
      title: '拍照写真'   // 标题设置
    }
  },
  // RAKUMART株式会社
  {
    path: '/introduction',
    name: 'introduction',
    component: Introduction,
    meta: {
      title: 'RAKUMART株式会社'   // 标题设置
    }
  },
  // fba
  {
    path: '/fba',
    name: 'fba',
    component: Fba,
    meta: {
      title: 'fba'   // 标题设置
    }

  },
  //ラクマート会員利用規約
  {
    path: '/guiyue',
    name: 'guiyue',
    component: Guiyue,
    meta: {
      title: 'ラクマート会員利用規約'   // 标题设置
    }

  },
  //代行手数料
  {
    path: '/poundage',
    name: 'poundage',
    component: Poundage,
    meta: {
      title: '代行手数料'   // 标题设置
    }
  },
  //私隐政策
  {
    path: '/secret',
    name: 'secret',
    component: Secret,
    meta: {
      title: 'プライバシーポリシー'   // 标题设置
    }
  },
  //常见问题
  {
    path: '/commonQuestion',
    name: 'commonQuestion',
    component: CommonQuestion,
    meta: {
      title: 'よくある質問'   // 标题设置
    }
  },
  //Option
  {
    path: '/option',
    name: 'option',
    component: Option,
    meta: {
      title: 'オプション費用'   // 标题设置
    }
  },
  //無在庫販売
  {
    path: '/wzk',
    name: 'wzk',
    component: Wzk,
    meta: {
      title: '無在庫販売'   // 标题设置
    }
  },
  //国际运费
  {
    path: '/freight',
    name: 'freight',
    component: Freight,
    meta: {
      title: '国際送料'   // 标题设置
    }
  },
  //汇率
  {
    path: '/rateEcharts',
    name: 'rateEcharts',
    component: rateEcharts,
    meta: {
      title: 'レート'   // 标题设置
    }
  },

  // 使用教程
  {
    path: '/course',
    name: 'course',
    component: Course,
    meta: {
      title: '利用ガイド'   // 标题设置
    }
  },
  //日历
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar,
    meta: {
      title: '日历'   // 标题设置
    }
  },
  // 公告
  {
    path: '/notice',
    name: 'notice',
    component: Notice,
    meta: {
      title: '公告'   // 标题设置
    }
  },
  {
    path: '/deliveryStatus',
    name: 'deliveryStatus',
    component: DeliveryStatus,
    meta: {
      title: '物流の状態'   // 标题设置
    }
  },
  // excel注文
  {
    path: '/excelZhuwen',
    name: 'excelZhuwen',
    component: () => import(/* webpackChunkName: "excelZhuwen" */ '../pages/user/excelZhuwen'),
    meta: {
      title: 'excel注文'   // 标题设置
    }
  },
  // base許可
  {
    path: '/oauth/authorize',
    name: 'authorization',
    component: () => import(/* webpackChunkName: "authorization" */ '../pages/authorization/authorization'),
    meta: {
      title: 'base許可'   // 标题设置
    }
  },
  // RAKUAMRT&1688
  {
    path: '/accountSynchronization',
    name: 'accountSynchronization',
    component: () => import(/* webpackChunkName: "accountSynchronization" */ '../pages/footList/accountSynchronization'),
    meta: {
      title: 'RAKUAMRT&1688'   // 标题设置
    }
  },



]
const router = new VueRouter({
  routes,
  // mode: 'history',
  // base: '/',
})
router.beforeEach((to, from, next) => {
  // if (to.path != '/') {
  getUser().then(res => {
    if (res.code == -1) {
      store.commit('userLogin', undefined)
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      // next({ path: '/Login' })
      return
    }
    localStorage.setItem('userInfo', JSON.stringify(res.data))
    store.commit('userLogin', res)

  })
  // }
  if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    if (localStorage.getItem('token')) {
      next();
    } else {
      // console.log(to);
      store.commit('toPage', to.fullPath)
      next({ path: '/Login' })
    }
  } else {
    next();
  }
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)

})
export default router
